var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-container",class:{ center: _vm.center }},[_c('div',{staticClass:"m-container__content",class:[_vm.contentClass],style:({ maxWidth: _vm.maxWidth })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }